import classNames from 'classnames'
import React from 'react'
import {TextButtonPriority} from 'wix-ui-tpa'
import {HoverStyles, TextButton} from 'wix-ui-tpa/cssVars'
import {ViewButtonProps} from './interfaces'
import {classes} from './view-button.st.css'

export const ViewButton = ({label, prefixIcon, onClick, dataHook}: ViewButtonProps) => (
  <div className={classes.container} onClick={onClick} onWheelCapture={e => e.stopPropagation()}>
    <TextButton
      data-hook={dataHook}
      className={classNames(classes.icon, classes.label)}
      priority={TextButtonPriority.secondary}
      hoverStyle={HoverStyles.underline}
      prefixIcon={prefixIcon}
    >
      {label}
    </TextButton>
  </div>
)
